module.exports = " <nav :class=\"{'fixed':fixed}\" _v-cd9c0614=\"\"> <ul _v-cd9c0614=\"\"> <li v-for=\"nav in getNavs\" v-link={name:nav.rname,params:{loginname:getUser.loginname}} v-if=\"nav.logined==getUser.success||nav.common\" _v-cd9c0614=\"\">{{nav.name}}<span class=uread v-if=\"nav.rname=='uread'\" v-show=\"getUser.unMes>0\" _v-cd9c0614=\"\">{{getUser.unMes}}</span></li> </ul> </nav> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/vue-html-loader/1.2.3/vue-html-loader!./~/.npminstall/vue-loader/8.5.3/vue-loader/lib/template-rewriter.js?id=_v-cd9c0614!./~/.npminstall/vue-loader/8.5.3/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
 ** module id = 176
 ** module chunks = 9
 **/